export default __webpack_public_path__ + "static/media/02_RoweOil-Commercial-EschweilerPhotography_M1A9958-3_3_flat_Shadows.6ace88a2.jpg";